import CoverageComplete from '../CoverageComplete'

export class RetrieveCoveragesCompleteResponse {
  coverageInfoData: CoverageComplete[]

  constructor(data: any = {}) {
    this.coverageInfoData =
      data.coverageInfoData?.map((cid: any) => new CoverageComplete(cid)) ?? []
  }
}
